import { Base } from "ui/Scripts/source/framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { CalendarTaskItems, ICalendarTaskItems } from "ui/Scripts/source/models/calendarTask/calendarTaskItems";
import { CalendarTaskPageData, ICalendarTaskPageData } from "./calendarTaskPageData";

export interface ICalendarTaskPage extends ICalendarTaskPageData {
    companies: ICompanyMenuItem[];
    calendar: ICalendarTaskItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
}

export class CalendarTaskPage extends CalendarTaskPageData implements ICalendarTaskPage {
    companies: CompanyMenuItem[];
    calendar: CalendarTaskItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;
    
    constructor();
    constructor(obj: ICalendarTaskPage);
    constructor(obj?: any) {
        super(obj);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.calendar = new CalendarTaskItems(obj && obj.calendar || null);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
    }
}
